module.exports = __webpack_public_path__ + "static/media/lcs_10y_n-1.3721f84d.csv";